(() => {
  if (!window.location.pathname.includes('/products/')) return;

  const legacyBundleSelectors = [
    '.bndlr-container',
    '[class*="bndlr-"]',
    '#bundler-target-element',
    '.bundler-target-element',
    '.bundler-volume-target-element',
    '#bundler-app',
    'iframe[src*="bundler.app"]'
  ];

  const removeLegacyBundleUi = (root = document) => {
    if (!root.querySelectorAll) return;
    root.querySelectorAll(legacyBundleSelectors.join(',')).forEach((node) => node.remove());

    root.querySelectorAll('a, small, span, button').forEach((node) => {
      const text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return;
      if (text.includes('Powered by Bundler') || text === 'Obtener un descuento') {
        const widget = node.closest('.bndlr-container, [class*="bndlr-"], #bundler-target-element, .bundler-target-element, .bundler-volume-target-element');
        (widget || node).remove();
      }
    });
  };

  const start = () => {
    removeLegacyBundleUi(document);
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) removeLegacyBundleUi(node);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
